import SDIcon from './SDIcon'

const IconCarbonMove = (props) => (
  <SDIcon title='Move' {...props}>
    <polygon points='25 11 23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11' />
  </SDIcon>
)

export default IconCarbonMove
